import { GridRenderEditCellParams, useGridApiContext } from '@mui/x-data-grid-pro';
import { ChangeEvent, useCallback, useContext } from 'react';
import { Tooltip } from '@mui/material';

import { GridPhoneInput } from '@styles/GridStyles';
import { ITextInputProps } from '../../inputs/TextInput';
import { GridRowContext } from './PhoenixGrid';


interface IGridColPhoneProps extends ITextInputProps {
  params: GridRenderEditCellParams;

  onChange?(event: ChangeEvent<HTMLInputElement>): void;
}

export const GridColPhone = ({ params, onChange, ...rest }: IGridColPhoneProps) => {
  const api = useGridApiContext();
  const rowContext = useContext(GridRowContext);
  const { id, field, value } = params;

  const handleChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    if (rowContext.errors[field]) {
      rowContext.resetError(field);
    }

    api.current.setEditCellValue({ id, field, value: event.target.value });
    onChange?.(event);
  }, []);

  return (
    <Tooltip title={rowContext.errors[field]}>
      <GridPhoneInput
        {...rest}
        unStyled
        value={String(value)}
        error={Boolean(rowContext.errors[field])}
        onChange={handleChange}
      />
    </Tooltip>
  );
};
